import { useState, useEffect } from 'react';
import styles from '../FilterOptions.module.scss';
import { Radio } from '@components';

type FilterProps = {
	header: any;
	meta: any;
	filterData: any;
	onChange: (val: any) => void;
};

export const FilterSelectSingle = (props: FilterProps) => {
	const { meta, filterData, onChange } = props;
	const [RadioOptions, setRadioOptions] = useState<any[]>([]);
	const filterOptions = meta?.filterOptions?.options ?? [];
	const changeRadioValue = (e: any) => {
		const newOpts = RadioOptions.map((opt) => {
			opt.checked = false;
			if (opt.value === e.target.value) opt.checked = true;
			return opt;
		});

		setRadioOptions(newOpts);

		const newFilterData = {
			...filterData,
			value: newOpts,
			columnField: meta?.databaseLocation,
			operatorValue: meta.operatorValue
				? meta.operatorValue
				: newOpts.filter((opt) => opt.checked).length > 1
					? 'In'
					: 'Is',
		};

		onChange(newFilterData);
	};

	const generateRadioOptions = (options: any[]) => {
		const opts = options.map((opt) => {
			return {
				checked: opt?.checked,
				value: typeof opt === 'string' ? opt : opt.value,
				label: typeof opt === 'string' ? opt : opt.label,
			};
		});
		return opts;
	};
	useEffect(() => {
		if (filterData?.value) {
			setRadioOptions(filterData.value);
		} else {
			setRadioOptions(generateRadioOptions(filterOptions));
		}
	}, [meta, filterData]);

	return (
		<div className={styles.inset}>
			{RadioOptions.map((opt) => (
				<div key={opt.value}>
					<Radio
						value={opt.value}
						checked={opt?.checked}
						onChange={changeRadioValue}
						name={''}
						label={opt?.label}
					/>
				</div>
			))}
		</div>
	);
};